import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { Link } from 'react-router-dom'
import Y from '../y18n'
import Styles from '../common/styles'

class NotFound extends Component {
  render () {
    const { classes } = this.props
    return (
      <div className={classes.textRow}>
        <h1 className={classes.warningText}>404</h1>
        <h4>{Y`The page you were looking for could not be found`}</h4>
        <p><Link to='/'>{Y`Back to the start page`}</Link></p>
      </div>
    )
  }
}

export default withStyles(Styles)(NotFound)



// WEBPACK FOOTER //
// ./src/common/not-found.js